export default {
  BLINK_DELAY: 1000,
}
